import styled from "styled-components";

export const MainContainer = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  height: 38px;
  @media (max-width: 610px) {
    padding: 10px;
    height: auto;
  }
`;
export const DownloadButton = styled.button`
  padding: 0 8px;
  height: 38px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #c1272d;
  outline: none;
  background: transparent;
  cursor: pointer;
  gap: 8px;
`;
export const FileImg = styled.img`
  width: 24px;
`;
export const DownloadText = styled.p`
  color: #c1272d;
  font-size: 14px;
  font-weight: 600;
`;
